

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getUnreadChatNotifications
// GETUNREADCHATNOTIFICATIONS   

const GETUNREADCHATNOTIFICATIONS= createAsyncThunk(
  "getUnreadChatNotifications/getUnreadChatNotifications",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUnreadChatNotificationsSlice = createSlice({
  name: "getUnreadChatNotificationsSlice",
  initialState: {
    getUnreadChatNotifications: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUnreadChatNotifications: (state) => {
        state.getUnreadChatNotifications.loading = false
        state.getUnreadChatNotifications.error = false
        state.getUnreadChatNotifications.data = []
        state.getUnreadChatNotifications.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUNREADCHATNOTIFICATIONS.fulfilled, (state, action) => {
      state.getUnreadChatNotifications = {
        ...state.getUnreadChatNotifications,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADCHATNOTIFICATIONS.pending, (state, action) => {
      state.getUnreadChatNotifications = {
        ...state.getUnreadChatNotifications,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADCHATNOTIFICATIONS.rejected, (state, action) => {
      state.getUnreadChatNotifications = {
        ...state.getUnreadChatNotifications,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUnreadChatNotificationsAction = {
    GETUNREADCHATNOTIFICATIONS,
};

export { getUnreadChatNotificationsAction };
export default getUnreadChatNotificationsSlice.reducer;
export const {setInitialStateOfgetUnreadChatNotifications} = getUnreadChatNotificationsSlice.actions